import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";
import IconLogoStyleFlag from "scmp-app/components/header/icon-logo-style-flag.svg";

export const Container = styled.div<ResponsiveStyledProps>`
  ${responsiveStyles}
`;

export const StyledLogoLink = styled(BaseLink)`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

export const StyledScmpStyleLogoFlag = styled(IconLogoStyleFlag)``;
